/** 鉴别订单（sfjs=0）回滚上一状态 */
export function resolvePreviousVerificationOrderStatus(status) {
  const s = Number(status);
  if (!Number.isFinite(s)) return null;
  switch (s) {
    case 6:
      return 0;
    case 5:
      return null;
    case 4:
      return 3;
    case 3:
      return 2;
    case 2:
      return 1;
    case 1:
      return 0;
    default:
      return null;
  }
}

/** 寄售订单（sfjs=1）回滚上一状态 */
export function resolvePreviousConsignmentOrderStatus(status) {
  const s = Number(status);
  if (!Number.isFinite(s)) return null;
  switch (s) {
    case 9:
      return 3;
    case 8:
      return 7;
    case 7:
      return 9;
    case 6:
      return 0;
    case 5:
      return null;
    case 4:
      return 3;
    case 3:
      return 2;
    case 2:
      return 1;
    case 1:
      return 0;
    default:
      return null;
  }
}

export function canRollbackVerificationOrderStatus(status) {
  return resolvePreviousVerificationOrderStatus(status) != null;
}

export function canRollbackConsignmentOrderStatus(status) {
  return resolvePreviousConsignmentOrderStatus(status) != null;
}



// WEBPACK FOOTER //
// ./src/util/orderStatusRollback.js